import { render, staticRenderFns } from "./color.vue?vue&type=template&id=0b9e949d&scoped=true&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"
import style0 from "./color.vue?vue&type=style&index=0&id=0b9e949d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e949d",
  null
  
)

export default component.exports